export type ContactEntry = {
    base: string,
    tag: string,
    image: string
}

export type SocialEntry = {
    base: string,
    name: string,
    shortcut: string,
    url: string,
    image: string
};

export type FooterEntry = {
    name: string,
    uri: string
};

export type SiteConfig = {
    metadata: {
        domain: string,
        description: string,
        isProd: boolean
    },
    contacts: ContactEntry[],
    socials: SocialEntry[],
    footer: FooterEntry[]
};

export const SiteConfig: SiteConfig = {
    metadata: {
        domain: "KujouAlya.de",
        description: "KujouAlya.de >.<",
        isProd: process.env.NODE_ENV === "production",
    },
    contacts: [
        {
            base: "Discord",
            tag: "Kujou_Alya",
            image: "alya/15.jpg"
        }
    ],
    socials: [
        {
            base: "Steam",
            name: "九条 アーリャ",
            shortcut: "/steam",
            url: "https://steamcommunity.com/id/KujouAlya/",
            image: "alya/0.jpg"
        },
        {
            base: "GitHub",
            name: "Suki ❤",
            shortcut: "/github",
            url: "https://github.com/suki-xoxo",
            image: "alya/13.jpg"
        },
        {
            base: "Laby",
            name: "KujouAlya",
            shortcut: "/laby",
            url: "https://laby.net/@KujouAlya",
            image: "alya/5.jpg"
        },
        {
            base: "Spotify",
            name: "KujouAlya",
            shortcut: "/spotify",
            url: "https://open.spotify.com/user/ng272hm3cfio8w5wu0y7tzajx?si=37eb6dec17494bf0",
            image: "alya/16.jpg"
        },
        {
            base: "Discord Server",
            name: "💕 KujouAlya.de 💕",
            shortcut: "/discord",
            url: "https://discord.com/invite/X4JJYD9HNc",
            image: "alya/15.jpg"
        }
    ],
    footer: [
        {
            name: "About",
            uri: "/about"
        },
        {
            name: "Contact",
            uri: "/contact"
        },
        {
            name: "Socials",
            uri: "/social"
        }
    ]
};